import React, { useState } from 'react';
import Icon from '../AppIcon';

const ResultsTabs = ({ activeTab = 'assessment', onTabChange }) => {
  const [currentTab, setCurrentTab] = useState(activeTab);
  const [isMobileExpanded, setIsMobileExpanded] = useState(false);

  const tabs = [
    {
      id: 'assessment',
      label: 'Assessment Summary',
      icon: 'ClipboardList',
      description: 'Overall performance metrics',
    },
    {
      id: 'mentor',
      label: 'Mentor Advice',
      icon: 'MessageSquare',
      description: 'Personalized improvement tips',
    },
    {
      id: 'feedback',
      label: 'Feedback Rating',
      icon: 'Star',
      description: 'Rate your experience',
    },
  ];

  const handleTabClick = (tabId) => {
    setCurrentTab(tabId);
    setIsMobileExpanded(false);
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  const activeTabData = tabs?.find(tab => tab?.id === currentTab);

  return (
    <>
      <div className="hidden md:block border-b border-border bg-card">
        <div className="flex items-center gap-1 px-6">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => handleTabClick(tab?.id)}
              className={`
                flex items-center gap-2 px-4 py-3 border-b-2 transition-all duration-150 ease-out
                ${
                  currentTab === tab?.id
                    ? 'border-primary text-primary font-medium' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'
                }
              `}
            >
              <Icon 
                name={tab?.icon} 
                size={18} 
                color={currentTab === tab?.id ? 'var(--color-primary)' : 'currentColor'} 
              />
              <span className="text-sm">{tab?.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="md:hidden bg-card border-b border-border">
        <button
          onClick={() => setIsMobileExpanded(!isMobileExpanded)}
          className="w-full px-4 py-3 flex items-center justify-between hover:bg-muted transition-colors duration-150 ease-out"
        >
          <div className="flex items-center gap-3">
            <Icon 
              name={activeTabData?.icon} 
              size={20} 
              color="var(--color-primary)" 
            />
            <div className="text-left">
              <div className="text-sm font-medium text-foreground">
                {activeTabData?.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {activeTabData?.description}
              </div>
            </div>
          </div>
          <Icon 
            name={isMobileExpanded ? 'ChevronUp' : 'ChevronDown'} 
            size={20} 
            color="var(--color-muted-foreground)" 
          />
        </button>

        {isMobileExpanded && (
          <div className="border-t border-border animate-accordion-down">
            {tabs?.map((tab) => (
              tab?.id !== currentTab && (
                <button
                  key={tab?.id}
                  onClick={() => handleTabClick(tab?.id)}
                  className="w-full px-4 py-3 flex items-center gap-3 hover:bg-muted transition-colors duration-150 ease-out border-b border-border last:border-b-0"
                >
                  <Icon 
                    name={tab?.icon} 
                    size={20} 
                    color="var(--color-muted-foreground)" 
                  />
                  <div className="text-left">
                    <div className="text-sm font-medium text-foreground">
                      {tab?.label}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {tab?.description}
                    </div>
                  </div>
                </button>
              )
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ResultsTabs;